let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("4p8Lt")]).then(() => parcelRequire('i5gh7'));